module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5gG9e"))).then(() => parcelRequire('2KbAe'));